import { useEffect, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { SIZE_STEP } from '../../utils/bab/bab.utils'

const RouteGuard = ({ children }) => {
  const history = useHistory()
  const location = useLocation()
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (location.pathname !== SIZE_STEP.path && isFirstRender.current) {
      history.replace(SIZE_STEP.path)
    } else {
      isFirstRender.current = false
    }
  }, [location.pathname, history])

  return children
}

export default RouteGuard
